// test1339
(1339 && 0);
